import {
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import {
  useAuth,
} from "../context/AuthContext";

export function ProtectedRoute() {
  const {
    user,
    loading,
  } = useAuth();

  const location =
    useLocation();

  if (loading) {
    return (
      <div className="center-page">
        <div
          className="spinner"
          role="status"
          aria-label="Loading account"
        />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from:
            location.pathname +
            location.search,
        }}
      />
    );
  }

  /*
   * Signed-in users must verify their email
   * before accessing private SARADIUM pages.
   */
  if (!user.emailVerification) {
    return (
      <Navigate
        to="/check-email"
        replace
        state={{
          email: user.email,

          from:
            location.pathname +
            location.search,
        }}
      />
    );
  }

  return <Outlet />;
}